import { Container } from "inversify";

const dicontainer = new Container();

export {dicontainer};